import React from "react";
import { CV } from "../components/cv";
import TomasBImg from "@/assets/images/tomas-b.png";

export default function CVTomasBoremalm() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Tomas Boremalm";
  }, []);

  return (
    <CV
      name="Tomas Boremalm"
      title="Senior Software Engineer & Solution Architect"
      subtitle="20+ years of experience in large-scale distributed systems, .NET and cloud — currently at Maersk"
      photo={TomasBImg}
      summary="Senior Software Engineer and Solution Architect with more than 20 years of experience. Known as a collaborative and approachable team member who works well across disciplines and builds strong relationships with colleagues and stakeholders. Brings hands-on expertise in large-scale distributed systems, with a practical, problem-solving mindset and a strong focus on teamwork and shared success."
      skills={{
        "Development & Platforms": [
          "Microsoft Azure",
          ".NET / C#",
          "AI assisted coding: Claude Code",
          "Microservices",
          "EpiServer/Optimizely (CMS & eCommerce certified, technical trainer)",
          "PIM (InRiver)",
          "Distributed systems",
          "Infrastructure as Code",
          "API design",
          "Software design",
          "DevOps",
        ],
        "Visualization & Analytics": [
          "Operational dashboards",
          "Metrics analysis",
          "Monitoring & Alerting",
        ],
        "Leadership": [
          "Cross-functional collaboration",
          "Technical leadership",
          "Stakeholder communication",
        ],
      }}
      experience={[
        {
          role: "Senior Software Engineer",
          company: "Maersk, Copenhagen",
          period: "Apr 2022 – Present",
          description:
            "Develop and maintain internal software products used by operations teams to manage contingency scenarios in Maersk's global container shipping network. The platform is considered a mission-critical MVP product, enabling operations teams to efficiently manage disruptions and maintain cargo flow across the network. Work across backend development, DevOps, and data engineering, building data-driven services that use multiple data sources to recommend optimized routes and automate decision-making where possible. The platform is built on a microservice architecture running on Microsoft Azure-based cloud infrastructure.",
          highlights: [
            "Tech: .NET, C#, Kafka, Claude Code, Azure, Kubernetes, SQL, NoSQL, Terraform, Grafana, GitHub Actions, DevOps",
          ],
        },
        {
          role: "Operational Intelligence Analyst (IT)",
          company: "Swedish Customs, Malmö",
          period: "Aug 2020 – Apr 2022",
          description:
            "Produced time-sensitive analytical intelligence reports and briefings for law-enforcement decision makers, often in direct coordination with field personnel and under significant time pressure. Integrated, cleaned, and analyzed large multi-source datasets to deliver actionable findings and defensible conclusions. Collaborated closely with investigators and prosecutors in multidisciplinary teams, translating rapidly evolving needs into clear assessments and recommendations.",
          highlights: [
            "Tech: Analyst's Notebook, Palantir products, Scripting",
          ],
        },
        {
          role: "Independent Software Consultant",
          company: "Self-employed",
          period: "2013 – Aug 2020",
          description:
            "Working with nordic organizations to deliver e-commerce solutions, combining solution architecture and software development, including large-scale digital platforms and data integrations that unified multiple operational systems. Certified Episerver/Optimizely developer and technical trainer.",
          highlights: [
            "Tech: EpiServer, C#, MSSQL, Azure, Google Cloud, Kubernetes, Elasticsearch, DevOps",
          ],
        },
        {
          role: "Senior Software Developer",
          company: "Empired Ltd (CapGemini), Sydney (Australia)",
          period: "Earlier",
          description:
            "Software consultant working on e-commerce solutions in Australia and New Zealand.",
          highlights: ["Tech: C# .NET, MSSQL, EpiServer, InRiver PIM"],
        },
        {
          role: "Software Developer",
          company: "inRiver, Malmö",
          period: "Earlier",
          description:
            "Software developer for a Product Information Management (PIM) platform.",
          highlights: ["Tech: C# .NET, MSSQL"],
        },
        {
          role: "Senior Software Developer",
          company: "C-Pen, Lund",
          period: "Earlier",
          description: "Developing software for a hand held text scanner.",
          highlights: ["Tech: C++"],
        },
        {
          role: "Software Developer",
          company: "Umetrics / Sartorius, Umeå",
          period: "Earlier",
          description:
            "Developing Multivariate Data Analysis software (SIMCA). Developer and responsible for data integration setup at the client facilities in Europe and North America.",
          highlights: ["Tech: C++, MSSQL"],
        },
      ]}
      education={[
        {
          degree: "BSc Electronics",
          institution: "Umeå University, Sweden",
          year: "",
        },
      ]}
    />
  );
}
